import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'occupants'
})
export class OccupantsPipe implements PipeTransform {

  transform(value: any): string {
console.log(value)
    return `${value['adults'] ? value['adults'] + (value['adults'] > 1 ? " Adults," : " Adult,") : ''} ${value['children'] ? value['children'] + (value['children'] > 1 ? " Children," : " Child,") : ''} ${value['pets'] ? value['pets'] + (value['pets'] > 1 ? " Pets," : " Pet,") : ''} ${value['infants'] ? value['infants'] + (value['infants'] > 1 ? " Infants," : " Infant,") : ''}`
  }

}
